const features = [
  {
    icon: 'ri-book-open-line',
    title: '免费阅读',
    desc: '海量触手漫画全集免费在线看，无需注册，无需付费，打开浏览器即可畅读所有触手漫画内容。',
  },
  {
    icon: 'ri-article-line',
    title: '下拉畅读',
    desc: '采用先进的下拉式阅读设计，无需翻页即可连续浏览触手漫画，带来流畅沉浸的阅读体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '热门触手漫画每日实时更新最新话，追更不等待。新作触手漫画定期上架，内容持续丰富。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 scroll-mt-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          为什么选择触手漫画
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 text-primary-500 rounded-2xl text-2xl">
                <i className={feature.icon}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}